import axios, { AxiosError, AxiosResponse } from 'axios';

export default interface RetryHandler {
  canHandle(error: AxiosError): boolean;
  retry(error: AxiosError): Promise<AxiosResponse>;
}

export class DefaultRetryHandler implements RetryHandler {
  canHandle(): boolean {
    return true;
  }

  retry(error: AxiosError): Promise<AxiosResponse> {
    return axios.request(error.config);
  }
}
